import { Box, Container, Typography } from '@mui/material';
import { psiTokens } from '../theme/psiTheme';
import CertificateLookupForm from '../components/CertificateLookupForm';
import { usePageMeta } from '../hooks/usePageMeta';

// /verify — look up ONE specific student's credential by Record ID. This is
// deliberately just the lookup form: browsing every issued certificate is a
// separate concern that lives at /certificates (see CertificatesPage.jsx).
// Don't merge these back into one page, see "Diplomas vs Certificates" in
// CLAUDE.md for why they're split.
export default function VerifyPage() {
  usePageMeta(
    'Verify a Credential',
    "Look up a PSI diploma or certificate by Record ID to verify a student's training and certification."
  );

  return (
    <Box sx={{ backgroundColor: psiTokens.background.tertiary, minHeight: '60vh' }}>
      <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
        {/* No small eyebrow above this on purpose, it's the page's only
            heading. */}
        <Typography variant="h3" sx={{ color: psiTokens.text.primary, fontWeight: 700, mb: 4 }}>
          Verify a student's PSI granted credentials
        </Typography>

        <CertificateLookupForm />
      </Container>
    </Box>
  );
}
